import {
    apiRequest,
    PromotionPeriodCreate
} from "../../../../../services/adapters/kepegawaian/kenaikanpangkatService"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", PromotionPeriodCreate, {
            body: query
        }, true)
    }


}

export default CreateRepository